import AService from '@/services/AService'

const ENTITY_NAME = 'controls';

export default class ControlService extends AService {
  async toggleControlsByBarcodeRangeAndLineIds(barcodeRangeId, associations, appointmentId = null, immediateTaggingId = null) {
    const params = {
      barcodeRangeId: barcodeRangeId,
      associations: associations,
      appointmentId: appointmentId,
      immediateTaggingId: immediateTaggingId
    }
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}/toggle`, params)
    return response.data
  }

  async getAll(params = {}) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }
}
